var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"locale-selector",class:{
      active: _vm.$i18n.locale === 'en',
      white: _vm.variant === 'white'
    },on:{"click":function($event){return _vm.changeLocale('en')}}},[_vm._v("\n    "+_vm._s(_vm.$t('nav.lang.en'))+"\n  ")]),_vm._v(" "),_c('span',{staticClass:"mx-1 locale-selector"},[_vm._v("/")]),_vm._v(" "),_c('span',{staticClass:"locale-selector",class:{
      active: _vm.$i18n.locale === 'zh-CN',
      white: _vm.variant === 'white'
    },on:{"click":function($event){return _vm.changeLocale('zh-CN')}}},[_vm._v("\n    "+_vm._s(_vm.$t('nav.lang.zh-cn'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }